import { render, staticRenderFns } from "./vcf.vue?vue&type=template&id=56296cf1&"
import script from "./vcf.vue?vue&type=script&lang=js&"
export * from "./vcf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports